export const PROCUREMENT_TYPE_MAP = {
  '': '-',
  PelelanganKhusus: 'Pelelangan Khusus',
  PemilihanLangsung: 'Pemilihan Langsung',
  TunjukLangsung: 'Tunjuk Langsung',
};

export const PROC_TYPE_OPTIONS = [
  { value: 'PelelanganKhusus', label: 'Pelelangan Khusus' },
  { value: 'PemilihanLangsung', label: 'Pemilihan Langsung' },
  { value: 'TunjukLangsung', label: 'Tunjuk Langsung' },
];

export const PROCUREMENT_TYPE_HEADER = {
  productHydro: '1',
  hydroCondensate: '2',
};

export const PROCUREMENT_TYPE_HEADER_LABEL = {
  1: 'Product Hydro',
  2: 'Hydro & Condensate',
};

export const AWARDING_STATUS = {
  open: 0,
  inProgress: 1,
  confirmed: 2,
};

export const AWARDING_SENDER = {
  pertamina: 1,
  companyMitra: 2,
};

export const AWARDING_STATUS_OPTIONS = [
  { value: 'Open', label: 'Open' },
  { value: 'InProgress', label: 'In Progress' },
  { value: 'Confirmed', label: 'Confirmed' },
];

export const getProcurementTypeLabel = type =>
  PROCUREMENT_TYPE_MAP[type] || type || '-';

export const getContractTypeLabel = contractType => {
  const value = parseInt(contractType, 10);
  if (value === 1) return 'TERM';
  if (value === 2) return 'SPOT';
  return '';
};

export const getAwardingStatusConfig = status => {
  const label = status || '-';
  const lower = label.toString().toLowerCase();

  if (lower === 'confirmed') return { label, color: 'success' };
  if (lower === 'in progress' || lower === 'inprogress') {
    return { label: 'In Progress', color: 'primary' };
  }
  if (lower === 'open') return { label, color: 'info' };
  if (lower === 'rejected' || lower === 'cancelled') {
    return { label, color: 'danger' };
  }
  return { label, color: 'secondary' };
};

export const displayValue = (value, fallback = '-') => {
  if (value === null || value === undefined || value === '') return fallback;
  return value;
};

export const mapAwardingToRow = item => {
  if (!item) return null;

  return {
    id: item.id ?? item.Id,
    noProc: item.procurementNumber ?? item.ProcurementNumber,
    title: item.titleProcurement ?? item.TitleProcurement,
    procType:
      item.procurementTypeLabel ??
      item.ProcurementTypeLabel ??
      getProcurementTypeLabel(item.procurementType ?? item.ProcurementType),
    productType: {
      main:
        item.procurementTypeHeaderLabel ??
        item.ProcurementTypeHeaderLabel ??
        PROCUREMENT_TYPE_HEADER_LABEL[
          item.procurementTypeHeader ?? item.ProcurementTypeHeader
        ] ??
        '-',
      sub: '-',
    },
    description: item.description ?? item.Description,
    status: item.statusWording ?? item.StatusWording ?? '-',
    unreadResponseCount:
      item.unreadResponseCount ?? item.UnreadResponseCount ?? 0,
    statusCode: item.status ?? item.Status ?? 0,
  };
};

export const unwrapAwardingList = result => {
  const payload = result?.data ?? result ?? {};
  const items = payload.items ?? payload.Items ?? [];
  const totalItems = payload.totalItems ?? payload.TotalItems ?? 0;

  return {
    items: items.map(mapAwardingToRow).filter(Boolean),
    totalItems,
  };
};

export const unwrapAwardingDetail = result => {
  const payload = result?.data ?? result ?? {};
  return payload && Object.keys(payload).length ? payload : null;
};

export const unwrapAwardingCollection = result => {
  const payload = result?.data ?? result ?? [];
  if (Array.isArray(payload)) return payload;
  return payload.items ?? payload.Items ?? [];
};
